/**
 * Roles are data, not code (created/edited via Settings → Roles). These
 * constants only cover the well-known System Admin and a few seed role names
 * used by mock data. The real permission set lives on each role record.
 */
export const SYSTEM_ADMIN_ROLE = 'System Admin';

export const SEED_ROLE_NAMES = {
  ADMIN: 'System Admin',
  REVIEWER: 'Reviewer',
  STORAGE_MANAGER: 'Storage Manager',
  DATA_ENTRY: 'Data Entry',
  SUPERVISOR: 'Supervisor',
};

export default SEED_ROLE_NAMES;
